import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/workspace.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import suppressRecaptchaTeardownError from './suppressRecaptchaTeardownError';

// Must run before React mounts so our listener is registered ahead of CRA's
// dev error overlay. Silences ONLY reCAPTCHA's post-sign-in teardown race —
// see the file for why that is safe and why it is scoped so tightly.
suppressRecaptchaTeardownError();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
